import { h } from 'preact'

interface HTMLWidgetProps{
  title: string
  html?: string
}

export default ({ title, html }: HTMLWidgetProps) => {
  return (
    <div class='custom-html-widget-wrapper'>
      {title
        ? (<div class='sitewidth'>
          <div class='col'>
            <h3 class='widget__heading'>{title}</h3>
          </div>
        </div>)
        : null}
      <section class='full-width custom-html' dangerouslySetInnerHTML={{ __html: html || '' }} />
    </div>
  )
}
